// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"dd88f60d","580":"cef34b14","632":"649f29e0","698":"7ae7f4ba","841":"cf9cb1ed","976":"6a516024"}[chunkId] + ".chunk.js";
};